<template>
    <v-container fluid>
        <v-row class="d-flex justify-space-between">
            <v-col v-if="seafarer.id != 0" class="position: absolute;">
                <v-btn v-if="inEditMode" class="ml-2 mr-2 mt-2" color="primary" @click="unlockClick(null)">
                    <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.lock') }}
                </v-btn>
                <v-btn
                    v-if="!inEditMode && !seafarer.gdpr_edit_lock"
                    class="ml-2 mr-2 mt-2"
                    color="primary"
                    @click="editClick()"
                >
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2 mt-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
            <v-col>
                <v-row v-if="!seafarer.gdpr_edit_lock" class="d-flex justify-end">
                    <v-col cols="1" class="d-flex align-center">
                        <v-btn depressed @click="fileClicked()" icon v-if="uploadedFile.link != ''">
                            <v-icon>fas fa-eye</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="5" class="mr-8 text-center">
                        <Upload v-model="uploadedFile" label="File" :isNavFile="true" @input="setFile"></Upload>
                    </v-col>
                </v-row>
                <v-row v-if="showPdfPreview">
                    <div
                        style="
                            display: show;
                            z-index: 9999999;
                            position: fixed;
                            top: 0px;
                            left: 0px;
                            background-color: rgba(255, 255, 255, 0.074);
                            width: 100%;
                            height: 100vw;
                        "
                    >
                        <div style="margin-top: 20px; margin-bottom: 40px; width: 40%; height: 100vh; margin: 0 auto">
                            <v-btn
                                style="float: right; margin-top: 50px; margin-bottom: 10px"
                                depressed
                                @click="closePDFpreview()"
                                icon
                            >
                                <v-icon large>fas fa-window-close</v-icon>
                            </v-btn>
                            <iframe
                                id="pdf-preview-div"
                                style="width: 100%; margin-bottom: 20px; height: 87vh; display: block"
                                :src="pdfLink"
                            >
                                <p>Your browser does not support iframes.</p>
                            </iframe>
                        </div>
                    </div>
                </v-row>
                <v-row>
                    <ImageViewer
                        :images="imageList"
                        :toggler="lightboxShow"
                        :index="lighboxIndex"
                        @closeViewer="lightboxShow = false"
                    >
                    </ImageViewer>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 80vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.experienceWithAzara') }}: &nbsp; {{ totalAzaraMonths }} &nbsp;
                        {{ $t('labels.months') }} &nbsp; &#40; {{ totalAzaraDays }} &nbsp; {{ $t('labels.days') }} &#41;
                    </v-card-title>
                    <v-card-text>
                        <SeafarerNavigationTable
                            :reload="reload"
                            :seafarer="seafarer"
                            :inEditMode="inEditMode"
                            :type="1"
                            @change="changeTotalAzara"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.experienceWithOtherCompanies') }}: &nbsp; {{ totalOthersMonths }} &nbsp;
                        {{ $t('labels.months') }} &nbsp; &#40; {{ totalOthersDays }} &nbsp;
                        {{ $t('labels.days') }} &#41;
                    </v-card-title>
                    <v-card-text>
                        <SeafarerNavigationTable
                            :reload="reload"
                            :seafarer="seafarer"
                            :inEditMode="inEditMode"
                            :type="2"
                            @change="changeTotalOther"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.onshoreExperience') }}: &nbsp; {{ totalShoreMonths }} &nbsp;
                        {{ $t('labels.months') }} &nbsp; &#40; {{ totalShoreDays }} &nbsp; {{ $t('labels.days') }} &#41;
                    </v-card-title>
                    <v-card-text>
                        <SeafarerNavigationTable
                            :reload="reload"
                            :seafarer="seafarer"
                            :inEditMode="inEditMode"
                            :type="3"
                            @change="changeTotalOnShore"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import SeafarerNavigationTable from './SeafarerNavigationTable';
import ImageViewer from './trinkets/ImageViewer';
import Upload from './trinkets/Upload';

export default {
    name: 'SeafarerNavigation',
    components: {SeafarerNavigationTable, ImageViewer, Upload},
    data: function () {
        return {
            showPdfPreview: false,
            pdfLink: '',
            imageList: [],
            pdfFormats: ['pdf', 'PDF'],
            imageFormats: ['png', 'jpg', 'jpeg'],
            lightboxShow: false,
            lighboxIndex: 0,
            initialLoad: false,
            languagesItems: [],
            lockKey: 'navigation',
            lockTimer: null,
            totalAzaraMonths: 0,
            totalAzaraDays: 0,
            totalOthersMonths: 0,
            totalOthersDays: 0,
            totalShoreMonths: 0,
            totalShoreDays: 0,
            uploadedFile: {
                name: '',
                link: '',
                public_link: '',
                original_name: '',
                upload_id: null,
            },
        };
    },
    computed: {},
    props: ['seafarer', 'inEditMode', 'reload'],
    emits: ['edit'],
    methods: {
        setFile(file) {
            this.uploadedFile = file;
            this.imageList.push(file.link);
        },
        closePDFpreview() {
            this.showPdfPreview = false;
            this.pdfLink = '';
        },
        fileClicked() {
            let link = this.uploadedFile.link;
            if (
                this.imageFormats.includes(
                    this.uploadedFile.original_name.slice(
                        ((this.uploadedFile.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                const index = this.imageList.indexOf(link);
                if (index !== null && index != -1) {
                    this.lighboxIndex = index;
                }
                this.lightboxShow = true;
            } else if (
                this.pdfFormats.includes(
                    this.uploadedFile.original_name.slice(
                        ((this.uploadedFile.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                this.showPdfPreview = true;
                this.pdfLink = this.uploadedFile.public_link;
            } else {
                window.open(link);
            }
        },
        changeTotalOther(e) {
            this.totalOthersMonths = e[0];
            this.totalOthersDays = e[1];
        },
        changeTotalOnShore(e) {
            this.totalShoreMonths = e[0];
            this.totalShoreDays = e[1];
        },
        changeTotalAzara(e) {
            this.totalAzaraMonths = e[0];
            this.totalAzaraDays = e[1];
        },
        editClick() {
            this.$emit('edit');
        },
        backClick() {
            this.$router.go(-1);
        },

        unlockClick() {
            this.$triggerReload();
            this.$emit('edit');
        },

        fetchData() {
            let vm = this;
            this.$APICall('get', 'seafarer-navigations-file/' + this.$route.params.id, {}, (data, success) => {
                if (success) {
                    vm.uploadedFile = data.file;
                    vm.imageList.push(data.file.link);
                }
            });
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            this.initialLoad = true;
            this.fetchData();
        }
    },
};
</script>

<style scoped></style>
